import React, { useEffect, useState, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../components/hooks/hooks-e-commerce/useAuth';
import { useLoginModal } from '../../contexts/LoginModalContext';
import { showToast } from '../../contexts/ToastNotification';

function AdminRoute({ children }) {
    const { user, isAuthenticated, initializeAuth } = useAuth();
    const [isAdmin, setIsAdmin] = useState(null);
    const [loading, setLoading] = useState(true);
    const { openLoginModal } = useLoginModal();
    const toastShown = useRef(false);
    const modalOpened = useRef(false);

    useEffect(() => {
        const verifyAdmin = async () => {
            console.log('🔍 Verifica accesso admin...');
            
            setLoading(true);
            
            // 🔥 Inizializza solo se necessario
            if (!isAuthenticated) {
                await initializeAuth();
            }
            
            // 🔥 Aspetta user
            if (!user) {
                console.log('⏳ Nessun utente, attendo...');
                setTimeout(() => setLoading(false), 500);
                return;
            }
            
            console.log('📊 user:', user);
            console.log('📊 user.status:', user?.status);
            
            const isUserAdmin = user?.status === 'admin' || user?.email === 'admin@gmail.com';
            
            if (!isAuthenticated || !isUserAdmin) {
                console.log('❌ Accesso negato');
                
                if (!toastShown.current) {
                    toastShown.current = true;
                    showToast('Accesso non autorizzato. Area riservata agli amministratori.', 'error', 4000);
                }
                
                if (!modalOpened.current && !isAuthenticated) {
                    modalOpened.current = true;
                    openLoginModal('login');
                }
                
                setIsAdmin(false);
                setLoading(false);
                return;
            }
            
            console.log('✅ Accesso admin consentito');
            setIsAdmin(true);
            setLoading(false);
        };
        
        verifyAdmin();
    }, [isAuthenticated, user, initializeAuth, openLoginModal]);

    if (loading) {
        return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
            <div style={{width: '20px', height: '20px', border: '2px solid #f3f3f3', borderTop: '2px solid #8B0000', borderRadius: '50%', animation: 'spin 0.8s linear infinite', marginRight: '10px'}}></div>
            Verifica autorizzazioni...
        </div>;
    }

    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default AdminRoute;
